import { render, staticRenderFns } from "./DiginetLineDetails.vue?vue&type=template&id=21797c96&"
import script from "./DiginetLineDetails.vue?vue&type=script&lang=js&"
export * from "./DiginetLineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports